import React from 'react';
// styles
import styles from './styles.module.scss';

const GetDisclaimerMessage = ({ message }) => {

  return (
    <div className={styles.disclaimerContainer}>
      <span className={styles.disclaimerHeading}>Disclaimer :</span>
      <div className={styles.disclaimerText}>
        {message}
      </div>
    </div>
  );
}

export default GetDisclaimerMessage;